'use strict';

var createRoot = require('@getgo/arborist');
var parentPlugin = require('@getgo/arborist/plugins/parent');
var nodeNamePlugin = require('@getgo/arborist/plugins/node_name');
var contextPlugin = require('@getgo/arborist/plugins/context');

var loggerErrorHandlerPlugin = require('./plugins/logger_error_handler');
var loggerWhenPlugin = require('./plugins/logger_when');
var loggerPlugin = require('./plugins/logger');

var consoleTargetPlugin = require('./plugins/logger_target_console');

module.exports = createRoot([
    parentPlugin,
    nodeNamePlugin,
    contextPlugin,
    loggerPlugin,
    loggerWhenPlugin,
    loggerErrorHandlerPlugin,
    consoleTargetPlugin
]);
